import {formChangeSuccess} from '../../../../utils/reducerOperations';
export function verifyFormChange(state, payload) {
    return formChangeSuccess(state, payload);
}
